// extracted by mini-css-extract-plugin
module.exports = {"items":"Items__items--19IwF"};